import devicepresets from "../../../../assets/images/docs/devicepresets.png";
import customdevices from "../../../../assets/images/blogs/pp201/customdevices.png";
import * as React from 'react';
export default {
  devicepresets,
  customdevices,
  React
};